var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdf = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3C2.39431 3 0.973684 4.44367 0.973684 6.20259V14.7974C0.973684 16.5563 2.39431 18 4.16833 18H32.8317C34.6057 18 36.0263 16.5563 36.0263 14.7974V6.20259C36.0263 4.44368 34.6057 3 32.8317 3H4.16833ZM0 6.20259C0 3.87174 1.87589 2 4.16833 2H32.8317C35.1241 2 37 3.87174 37 6.20259V14.7974C37 17.1283 35.1241 19 32.8317 19H4.16833C1.87589 19 0 17.1283 0 14.7974V6.20259Z",
    fill: "#FF3E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1537 11.9323C20.8824 12.4236 20.4726 12.8248 19.9751 13.0862C19.4152 13.3721 18.7926 13.5139 18.1638 13.4989H15.7047V7.00121H18.1638C18.7931 6.98542 19.4166 7.12416 19.9794 7.40527C20.4756 7.66104 20.8843 8.05819 21.1537 8.54622C21.4356 9.06432 21.5774 9.64668 21.5653 10.236C21.5771 10.8274 21.4353 11.4117 21.1537 11.9323ZM19.4594 11.606C19.6355 11.4257 19.772 11.2107 19.86 10.9748C19.9481 10.7389 19.9858 10.4873 19.9707 10.236C19.9859 9.98508 19.9482 9.73371 19.8601 9.49814C19.7721 9.26257 19.6356 9.048 19.4594 8.86818C19.0653 8.52332 18.5506 8.34778 18.0273 8.37982H17.2798V12.0922H18.0273C18.5502 12.1239 19.0645 11.9493 19.4594 11.606Z",
    fill: "#FF3E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5751 13.499V11.2193L12.5522 11.2214C13.0009 11.2352 13.4464 11.1426 13.8522 10.9513C14.1886 10.7875 14.469 10.5281 14.6581 10.2058C14.8434 9.87615 14.9369 9.50313 14.929 9.12535C14.9432 8.83902 14.8965 8.55293 14.7919 8.2859C14.6874 8.01886 14.5273 7.77695 14.3223 7.57602C13.9172 7.19354 13.3257 7.00124 12.5522 7.00124H10V13.499H11.5751ZM12.3767 8.261C13.0094 8.261 13.3257 8.54911 13.3257 9.12535C13.3257 9.68285 13.0094 9.95874 12.3767 9.95298H11.5751V8.261H12.3767Z",
    fill: "#FF3E4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7064 8.2524V7.00124H22.4577V13.499H24.035V10.8713H26.0976V9.67638H24.035V8.2524H26.7064Z",
    fill: "#FF3E4C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf.83922873ab2af9b6fe4c60b312c90393.svg";